module.exports = __webpack_public_path__ + "static/media/sokeGeniesse.07969680.jpg";